import { twMerge } from "tailwind-merge";
import { IPoweredBy } from "../../interfaces/poweredBy.interface";

const PoweredBy = ({ content }: { content: IPoweredBy }) => {
  const descText = content?.descText?.replace(/\\r\\n|\\n|\\r/g, "") ?? "";
  return (
    <div
      dangerouslySetInnerHTML={{
        __html: descText ?? "",
      }}
      className={twMerge("text-center", content.customClass)}
      data-testid="poweredByText"
    ></div>
  );
};

export default PoweredBy;
